<script setup>
import { computed } from 'vue'
import { Select } from '@drama/ui'

import AuditCard from './AuditCard.vue'
import AuditFlow from './AuditFlow.vue'
import AuditId from './AuditId.vue'
import AuditScene from './AuditScene.vue'
import { clockTime, fullTime, shortId, useAuditText } from './audit-text.js'
import { asArray } from './run-observer.js'

const props = defineProps({
  run: { type: Object, required: true },
  snapshot: { type: Object, required: true },
  pack: { type: Object, required: true },
  branch: { type: Object, required: true },
  // 当前分支最近一次回合请求与它的模型阶段（modelStages 的结果）；还没有请求时为 null 与空数组。
  request: { type: Object, default: null },
  stages: { type: Array, required: true },
})
const branchId = defineModel('branchId', { type: String, required: true })

const { t, tr } = useAuditText()
const branchOptions = computed(() => asArray(props.snapshot.branches).map((item) => ({
  value: item.branch_id,
  label: tr('branch.option', {
    id: shortId(item.branch_id),
    state: item.branch_id === props.snapshot.active_branch_id ? tr('branch.active') : item.candidate ? tr('branch.candidate') : '—',
    turns: asArray(item.turns).length,
  }),
})))
const currentBranchLabel = computed(() => branchOptions.value.find((option) => option.value === branchId.value)?.label ?? '—')
</script>

<template>
  <div class="au-tab">
    <div class="au-split">
      <AuditScene :pack="pack" :branch="branch" />
      <AuditCard :title="tr('overview.runInfo')">
        <dl class="au-kv">
          <dt>{{ tr('overview.player') }}</dt>
          <dd>{{ run.user_email || t('visualGameAdmin.novelRuns.list.unknownUser') }}</dd>
          <dt>{{ tr('overview.work') }}</dt>
          <dd :title="run.pack_id">{{ run.pack_title }}</dd>
          <dt>{{ tr('overview.packageHash') }}</dt>
          <dd><AuditId :id="run.package_hash" /></dd>
          <dt>{{ tr('overview.created') }}</dt>
          <dd :title="fullTime(run.created_at)">{{ clockTime(run.created_at) }}</dd>
          <dt>{{ tr('overview.lastPlayed') }}</dt>
          <dd :title="fullTime(run.last_played_at)">{{ clockTime(run.last_played_at) }}</dd>
          <dt>{{ tr('overview.branch') }}</dt>
          <dd>
            <Select v-if="branchOptions.length > 1" v-model="branchId" :options="branchOptions" size="sm" data-testid="observer-branch" />
            <span v-else>{{ currentBranchLabel }}</span>
          </dd>
        </dl>
      </AuditCard>
    </div>
    <AuditFlow :request="request" :stages="stages" />
  </div>
</template>
